import { render, staticRenderFns } from "./TemplateSummaries.vue?vue&type=template&id=f8235e60&scoped=true&"
import script from "./TemplateSummaries.vue?vue&type=script&lang=js&"
export * from "./TemplateSummaries.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSummaries.vue?vue&type=style&index=0&id=f8235e60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8235e60",
  null
  
)

export default component.exports